export enum DataPackageTypeEnum {
    DataRequestMetadata = 'DataRequestMetadata',
    StudyMetadata = 'StudyMetadata',
    RequestedStudyIPD = 'RequestedStudyIPD',
    StudyIPD = 'StudyIPD',
    ResearchVMResults = 'ResearchVMResults',
}
